// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
  // Initialize Swiper slider for .logo-list__slider element
  new Swiper('.logo-list__slider', {
    // Base settings (mobile-first)
    slidesPerView: 1,       // Show 1 slide by default
    slidesPerGroup: 1,      // Scroll 1 slide at a time
    loop: true,           // Disable infinite loop (no looping)
    spaceBetween: 10,       // Space between each slide (20px)
    autoplay: {
      delay: 3000,         // Autoplay delay (3000ms), adjust as needed
      disableOnInteraction: false, // Continue autoplay after user interaction
    },
    a11y: {
      enabled: false,      // Disable accessibility module if not needed
    },
    
    // No pagination (dots) or navigation arrows, as in the original config
    
    // Responsive breakpoints configuration
    breakpoints: {
      450: {
        slidesPerView: 2,   // At >=450px show 2 slides
        slidesPerGroup: 1,  // Scroll 2 slides at a time
      },
      650: {
        slidesPerView: 3,   // At >=650px show 3 slides
        slidesPerGroup: 1,  // Scroll 3 slides at a time
      },
      900: {
        slidesPerView: 4,   // At >=900px show 4 slides
        slidesPerGroup: 1,  // Scroll 4 slides at a time
      },
      1050: {
        slidesPerView: 5,   // At >=1050px show 5 slides
        slidesPerGroup: 1,  // Scroll 5 slides at a time
      },
      1200: {
        slidesPerView: 6,   // At >=1200px show 6 slides
        slidesPerGroup: 1,  // Scroll 6 slides at a time
      },
      1400: {
        slidesPerView: 8,   // At >=1400px show 8 slides
        slidesPerGroup: 1,  // Scroll 1 slide at a time
      },
    }
  });
});